<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="100px;"
      label-position="top"
    >
      <el-form-item
        :label="$l('label_milestone_type') || '里程碑'"
        prop="milestonesType"
      >
        <dict-select
          clearable
          filterable
          v-model="formData.milestonesType"
          :placeholder="$l('tips_select_milestone_type') || '请选择里程碑'"
          url="/sys/common/dict/system"
          :body="{ dictType: 'milestonesType' }"
        />
      </el-form-item>
      <el-form-item
        :label="$l('label_milestone_begin') || '开始日期'"
        prop="beginTime"
      >
        <el-date-picker
          clearable
          v-model="formData.beginTime"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          :placeholder="$l('tips_select_milestone_begin') || '请选择开始日期'"
          style="width:100%"
        />
      </el-form-item>
      <el-form-item
        :label="$l('label_milestone_end') || '结束日期'"
        prop="endTime"
      >
        <el-date-picker
          clearable
          v-model="formData.endTime"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          :placeholder="$l('tips_select_milestone_end') || '请选择结束日期'"
          style="width:100%"
        />
      </el-form-item>
      <el-form-item
        :label="$l('label_milestone_desc') || '节点说明'"
        prop="milestonesDesc"
      >
        <el-input
          clearable
          style="width:100%;"
          size="small"
          v-model="formData.milestonesDesc"
          :placeholder="$l('label_milestone_rules_desc') || '请输入节点说明'"
          type="textarea"
          maxlength="1000"
          rows="3"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="确认节点" prop="isChecked">
        <el-radio-group size="small" v-model="formData.isChecked" disabled>
          <el-radio label="Y">是</el-radio>
          <el-radio label="N">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" prop="milestonesStatus">
        <dict-select
          v-model="formData.milestonesStatus"
          size="small"
          placeholder="请选择节点状态"
          :body="{dictType:'milestonesStatus'}"
        />
      </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
// import { detailApi, saveApi } from '@api/projectManager/infoSchedule'
export default {
  props: {
    prjCode: {
      default: '',
      type: String,
    },
  },
  watch: {
    // prjCode: {
    //   handler (val) {
    //     console.log('watch', val)
    //     this.formData.prjCode = val
    //   }
    // }
  },
  data() {
    return {
      formData: {
        milestonesDesc: '',
        scheduleCode: '',
        prjCode: '',
        milestonesType: '',
        beginTime: '',
        endTime: '',
        isChecked: 'N',
        milestonesStatus: 'prjStaStandby',
      },
      rules: {
        milestonesDesc: [
          {
            required: true,
            message: this.$l('label_milestone_rules_desc') || '请输入节点说明',
            trigger: 'blur',
          },
        ],
        milestonesType: [
          {
            required: true,
            message: this.$l('label_milestone_rules_type') || '请选择节点类型',
            trigger: 'blur',
          },
        ],
        beginTime: [
          {
            required: true,
            message: this.$l('label_milestone_rules_begin') || '请选择开始日期',
            trigger: 'change',
          },
        ],
        endTime: [
          {
            required: true,
            message: this.$l('label_milestone_rules_end') || '请选择结束日期',
            trigger: 'change',
          },
        ],
        // isChecked: [
        //   { required: true, message: '是否确认节点', trigger: 'change' }
        // ],
        // milestonesStatus: [
        //   { required: true, message: '请选择节点状态', trigger: 'blur' }
        // ]
      },
    }
  },
  methods: {
    // 加载表单数据（新增，编辑）
    fromLoad(ref, val = {}) {
      this.init()
      if (ref !== 'add') {
        let param = { scheduleCode: val }
        this.$api.scheduleDetailApi(param).then((res) => {
          this.formData = res.body
        })
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.prjCode) {
            this.formData.prjCode = this.prjCode
          }
          this.$api.scheduleSaveApi(this.formData).then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('tips_save_ok') || '保存成功！',
              type: 'success',
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    // 初始化表单数据
    init() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
        this.reset()
      }
    },
    reset() {
      this.formData = {
        milestonesDesc: '',
        scheduleCode: '',
        prjCode: '',
        milestonesType: '',
        beginTime: '',
        endTime: '',
        isChecked: 'N',
        milestonesStatus: 'prjStaStandby',
      }
    },
  },
}
</script>
